export interface RegistriaRequestShippingAddress {
  address1: string;
  address2: string;
  city: string;
  country: string;
  state: string;
  zip: string;
}
